import { captureMessage } from '@sentry/node';
import { Response } from 'express';

import { USER_LOGOUT_ROUTE } from '@r1-frontend/shared/constants/routes';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

// todo: переделать чтобы это был не action
export const logout = (res?: Response) => {
    return () => {
        if (isServerSide()) {
            if (!res) {
                captureMessage(
                    'функция auth.logout была вызвана без параметра Response на серверной стороне',
                    { level: 'error' },
                );
                console.error('функция auth.logout была вызвана без параметра Response на серверной стороне');
                return;
            }

            res.redirect(`${USER_LOGOUT_ROUTE}?referrer=${res.req.url}`);
        } else {
            window.location.replace(`${USER_LOGOUT_ROUTE}?referrer=${location.href}`);
        }
    };
};
